import { addDomain } from '../../util/index';

let urls = {
    // 砍价活动详情
    bargainActivityDetail: '/knightCard/bargain/v1_0/bargain_activity_detail',

    // 砍价活动列表
    bargainActivityList: '/knightCard/bargain/v1_0/bargain_activity_list',

    // 用户砍价团列表
    bargainGroupList: '/knightCard/bargain/v1_0/bargaining_group_list',

    // 新增砍价团
    createGroup: '/knightCard/bargain/v1_0/create_group',

    // 商品须知
    explainTemplate: '/knightCard/bargain/v1_0/explain_template',
};

let marketingUrls = {
    // 砍一刀
    doBargain: '/knightCard/bargain/v1_0/do_bargain',

    // 检验游客是否参与砍价
    checkBargain: '/knightCard/bargain/v1_0/bargain_group_check_auth_new',

    // 用户砍价团详情
    bargainGroupDetail: '/knightCard/bargain/v1_0/bargain_group_detail',

    // 通过口令再次触发砍价
    reBargainByCommand: '/knightCard/bargain/v1_0/bargain_again_by_command',

    // captcha_image
    captchaImage: '/knightCard/bargain/v1_0/captcha_image',

    // 校验短信验证码
    checkVerificationCode: '/knightCard/bargain/v1_0/check_verification_code',

    // 发送短信验证码
    sendVerificationCode: '/knightCard/bargain/v1_0/send_verification_code',

    // 获取需要通知的成功团
    getNotifyGroup: '/knightCard/bargain/v1_0/user_unknow_success_group',

    // 支付成功后红包弹窗
    paySuccPacket: '/activity/redPacket/order/v1_0/addRedPacket',
    // 支付成功后福袋或红包
    addOrderReward: '/activity/redPacket/order/v1_0/addOrderReward',

    // 创建下单奖励接口(骑士卡和商城调用 - 根据配置创建红包或者福袋)
    addOrderReward: '/activity/redPacket/order/v1_0/addOrderReward',

    // 悬浮窗红包信息
    iconRedPacketDetail: '/activity/redPacket/order/v1_0/iconRedPacketDetail',

    // 最高红包金额的接口(弹窗展示)
    orderMaxAmountInfo: '/activity/redPacket/order/v1_0/orderMaxAmountInfo',

    // 获取走马灯信息
    getCutMarqueeData: '/knightCard/bargain/v1_0/getMarqueeData',
};

export default function({ domain, marketingDomain }) {
    return { ...addDomain(urls, domain), ...addDomain(marketingUrls, marketingDomain) };
}
